module.exports = __webpack_public_path__ + "resources/img/zoom-ui-customizations-02.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom-ui-customizations-02.png
// module id = 1398
// module chunks = 0